<script lang="ts">
    import {getModalContext} from './modal-context';
    import {getLocalization} from 'core/svelte-context/context';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';

    const localize = getLocalization();
    const context = getModalContext();

    export let dataQa: string | null = null;
</script>

<KpButton data-dismiss="modal" data-qa="{dataQa}" on:click={() => context.modalWindowActions.cancel()}>
    {localize(/* @kp-localization commons.zavrit */ 'commons.zavrit')}
</KpButton>
